<!-- =========================================================================================
    File Name: Rsvp.vue
    Description: RSVP Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class=" flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                      <!-- <img src="/logo.png" alt="logo" class="mx-auto" style="max-width:100px" /> -->
                        <div class="vx-col lg:block  mx-auto self-center">
                          <!-- <img src="/logo.png" alt="logo" class="mx-auto" style="max-width:100px" /> -->
                            <div class="px-10 pt-10 register-tabs-container" v-html="content">
                            </div>
                        </div>

                    </div>
                </div>
            </vx-card>
        </div>
    </div>

<!-- <div class="vx-card__title mb-4">
<h4 class="mb-4 mx-auto text-center">Informativa privacy</h4>
<p class="mb-4 mx-auto text-center">AI SENSI DELL’ART. 13 - Regolamento UE 2016/679 (GDPR)</p>
</div>
<p class="mb-2">1.Premessa</p>
<p class="mb-1">Noi di Dromedian S.r.l. curiamo con particolare attenzione, anche in rapporto ai nostri servizi,
la trasparenza nelle policy aziendali e il rispetto della privacy dei nostri utenti.
Di seguito riassumiamo le procedure, le finalità, le modalità e le motivazioni con cui raccogliamo,
analizziamo e utilizziamo i dati.
Come essi vengono gestiti e come sono disciplinati i rapporti con eventuali terze parti.</p>
<p class="mb-1">Le presenti norme sulla privacy descrivono l'utilizzo dei dati personali dell'utente da parte
di Dromedian Srl in occasione della consultazione dei nostri siti dromedian.it ed concilium.cloud,
dell'interazione con i servizi offerti e dell'acquisto dei nostri prodotti e servizi.
Esse servono inoltre per far conoscere all'utente i
diritti legati alla privacy e la relativa protezione offerta dall'ordinamento giuridico.</p>
<p class="mb-1">Preghiamo l'utente di leggere le presenti norme sulla privacy nonché le ulteriori norme sulla privacy che
		dovessimo fornirgli, in modo da essere edotto sull'utilizzo dei suoi dati personali da parte nostra.
		Le presenti norme sulla privacy sono state aggiornate in data 14 maggio 2020. Per qualsiasi
		domanda o per esercitare un diritto legato alla privacy si prega di seguire le istruzioni indicate
		nelle presenti norme sulla privacy.</p>
<p class="mb-3">Consultare la sezione Come contattare Dromedian per una domanda sulla
				privacy nel prosieguo.
		Abbiamo creato un indirizzo specifico cui potrà indirizzare tutte le sue domande o richieste : <a href="mailto:privacy@dromedian.it">privacy@dromedian.it</a>
</p>
<p class="mb-2">2. I nostri siti Dromedian ed CONCILIUM</p>
<p class="mb-3">I siti dromedian.it ed concilium.cloud si occupano della vendita di servizi di votazioni
		online e servizi tecnici e consulenziali. La fruizione del sito non è destinata ai minori e non raccogliamo scientemente i
		dati che li riguardano.
			Dromedian S.r.l. Via Po, 43 - 66020 San Giovanni Teatino (CH), è il titolare del trattamento dei dati per questi due siti.</p>
<p class="mb-2">3. Dati personali che possiamo raccogliere</p>
<p class="mb-1">I dati personali, o informazioni personali,
					sono informazioni relative a un qualsiasi soggetto dalle quali si possa desumere la sua identità.
					Sono quindi esclusi i dati da cui sia stata rimossa l'identità dell'utente (dati anonimi).</p>
<p class="mb-1">Raccogliamo una serie di informazioni relative ai nostri clienti e agli utenti che
		visitano i siti sopra indicati. Detti dati personali sono riconducibili alle categorie di seguito esposte.</p>
<p class="mb-1">
		Dati identificativi: comprendono titolo, nome, cognome, nome utente o altri dati identificativi nonché la
		versione crittografata delle credenziali di accesso dell'utente. Qualora l'utente comunichi con noi tramite i social media,
		questa categoria di dati include anche il nome utente impiegato su detto social media.
</p>
<p class="mb-1">Dati di contatto: comprendono indirizzo di fatturazione, indirizzo di spedizione, indirizzo e-mail e recapiti telefonici.</p>
<p class="mb-1">Dati finanziari e dati sulle operazioni: comprendono le informazioni relative ai pagamenti da parte dell'utente e in suo favore nonché ulteriori
		informazioni relative a prodotti e servizi acquistati da noi.
		Dati di profilatura: comprendono nome utente e password dell'utente, acquisti e ordini da questi effettuati,
			le sue preferenze, recensioni e contributi ai sondaggi, insieme a qualsiasi dato di profilatura da noi aggiunto (ad esempio, analisi e profilazione).
</p>
<p class="mb-1">Dati finanziari e dati sulle operazioni: comprendono le informazioni relative ai pagamenti da parte dell'utente e in suo favore nonché ulteriori
		informazioni relative a prodotti e servizi acquistati da noi.
		Dati di profilatura: comprendono nome utente e password dell'utente, acquisti e ordini da
		questi effettuati, le sue preferenze, recensioni e contributi ai sondaggi, insieme a qualsiasi dato di profilatura da noi aggiunto (ad esempio, analisi e profilazione).
</p>
<p class="mb-1">Dati di utilizzo: comprendono le informazioni relative all'utilizzo del nostro sito, nonché dei nostri prodotti e servizi.</p>
<p class="mb-1">Dati di monitoraggio: comprendono le informazioni relative all'utente che noi, o dei soggetti terzi, raccogliamo a partire da cookie e tecnologie di tracciamento simili,
		quali web beacon, pixel e dati identificativi del dispositivo mobile.</p>
<p class="mb-1">Dati di mercato e dati commerciali: comprendono le preferenze relative alla ricezione di comunicazioni di marketing diretto da parte nostra e da soggetti terzi e tutte le preferenze
		legate alle comunicazioni.
		Inoltre, raccogliamo, utilizziamo e condividiamo Dati aggregati quali dati statistici e demografici per qualsivoglia finalità.
		I Dati aggregati potrebbero derivare dai dati personali dell'utente sebbene non siano considerati dati personali ai sensi della normativa poiché non rivelano l'identità dell'utente,
		direttamente o indirettamente. Ad esempio, potremmo aggregare i Dati di utilizzo per calcolare la percentuale di utenti che accedono a una specifica funzionalità del sito. Ciononostante, qualora combinando o collegando i Dati aggregati con i dati personali dell'utente
			questi possano direttamente o indirettamente identificarlo, i dati combinati saranno trattati alla stregua dei dati personali ai sensi delle presenti norme sulla privacy.
</p>
<p class="mb-1">Non raccogliamo Dati sensibili relativi all'utente (essi comprendono i dati che rivelino l'origine razziale o etnica, le convinzioni religiose o filosofiche, la vita sessuale, l'orientamento sessuale, le opinioni politiche, l'appartenenza sindacale, le informazioni relative allo
			stato di salute nonché i dati genetici e biometrici). Inoltre, non raccogliamo i dati giudiziari relativi all'utente. Tutti i dati personali presenti sui design o sui prodotti saranno trattati alla stregua dei dati personali ordinari.</p>
<p class="mb-3">Si prega inoltre di notare che, qualora l'utente intendesse non condividere con noi taluni
		dati personali oppure rifiutasse qualsivoglia contatto da parte nostra, potremmo non essere in grado di fornire i prodotti e servizi richiesti.</p>
<p class="mb-2">4. Come avviene la raccolta dei dati personali?</p>
<p class="mb-1">Di seguito sono elencati i diversi metodi di raccolta dei dati dall'utente e dell'utente di cui ci avvaliamo.
		Interazione diretta. L'utente decide di comunicarci i Dati identificativi, di contatto e finanziari con la compilazione
		di un modulo o comunicando detti dati via posta, telefono, e-mail o tramite chat o social media.
</p>
<p class="mb-1">Sono inclusi i dati personali comunicati dall'utente quando questi:</p>
<ul>
		<li>si iscrive alla CONCILIUM newsletter;</li>
		<li>inoltra richieste o sollecita la ricezione di informazioni;</li>
		<li>crea un account sul nostro sito;</li>
		<li>si iscrive ad un nostro webinar;</li>
		<li>ordina i nostri prodotti o servizi;</li>
		<li>richiede materiale commerciale;</li>
		<li>ci contatta sui social media;</li>
		<li>prende parte a un concorso, promozione o sondaggio;</li>
		<li>contatta il servizio clienti;</li>
		<li>pubblica un commento o una recensione relativa ai nostri prodotti o servizi.</li>
</ul>
<p class="mb-1">Tecnologie o interazioni automatizzate. Quando l'utente interagisce con noi, anche tramite i nostri siti,
		potremmo raccogliere Dati tecnici relativi ai suoi dispositivi nonché alle azioni e ai modelli di navigazione. Potremmo inoltre raccogliere dei Dati di monitoraggio qualora l'utente consulti il nostro sito o quando faccia click su una nostra pubblicità (ivi incluse quelle pubblicate su siti di soggetti terzi).
		Soggetti terzi o fonti di dominio pubblico. Potremmo ricevere dei dati personali relativi all'utente da diverse categorie di soggetti terzi, tra cui:
</p>
<ul class="mb-3">
		<li>dati tecnici e/o di monitoraggio da fornitori di servizi di analisi, reti pubblicitarie e fornitori di servizi di ricerca;</li>
		<li>dati di contatto, finanziari e sulle operazioni derivanti da fornitori di servizi di
					pagamento nonché da servizi di prevenzione delle frodi;</li>
		<li>dati da qualsiasi soggetto terzo a cui sia stata autorizzata dalla normativa o dall'utente stesso la condivisione con noi dei dati personali di detto utente, per esempio tramite social media o siti di recensioni.</li>
</ul>
<p class="mb-2">5. Come usiamo i dati personali dell'utente</p>
<p class="mb-1">Usiamo i dati personali entro i limiti previsti dalla legge. In generale usiamo i dati personali nelle circostanze di seguito indicate.</p>
<ul class="mb-1">
		<li>Qualora dovessimo eseguire un contratto in via di conclusione o già concluso con l'utente. Ad esempio, il contratto che consiste nell'acquisto di un prodotto/servizio da parte dell'utente. </li>
		<li>Qualora sia necessario per perseguire i nostri interessi legittimi, sempre che gli interessi e i diritti fondamentali dell'utente non prevalgano su di essi. Ad esempio, in occasione dei controlli antifrode durante
				la procedura di pagamento dell'ordine.</li>
		<li>Qualora dovessimo ottemperare a obblighi imposti da leggi o regolamenti. Ad esempio, per la conservazione della documentazione relativa alle vendite per ragioni fiscali.</li>
</ul>
<p class="mb-1">
		In generale, il fondamento giuridico sul quale basiamo il trattamento dei dati personali dell'utente non include il consenso dello stesso salvo qualora espressamente previsto dalla legge, ad esempio per l'invio di talune comunicazioni di marketing diretto.
			Nei casi in cui il fondamento giuridico si basi sul consenso, l'utente ha il diritto di revocare il consenso in qualsiasi momento.
</p>
<p class="mb-3">
		Per ulteriori informazioni si prega di confrontare I fondamenti giuridici su cui ci basiamo per il trattamento
		dei dati personali con la base giuridica sulla quale fondiamo il trattamento dei dati personali.
</p>
<p class="mb-2">6. I fondamenti giuridici su cui ci basiamo per il trattamento dei dati personali.</p>
<p class="mb-1">La seguente tabella offre una descrizione di tutti i potenziali utilizzi dei dati personali e il relativo fondamento giuridico.
			Abbiamo inoltre indicato il nostro interesse legittimo, se del caso.</p>
<table style="width:100%" class="border-collapse">
		<tr>
				<th class="p-2 border border-solid d-theme-border-grey-light">Finalità/Attività</th>
				<th class="p-2 border border-solid d-theme-border-grey-light">Categoria di dati</th>
				<th class="p-2 border border-solid d-theme-border-grey-light">Fondamento giuridico del trattamento</th>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Fondamento giuridico del trattamento</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi Di contatto</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Esecuzione di un contratto</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per l'elaborazione e la consegna di un ordine, ivi inclusi:<br>
						(a) la gestione del pagamento e delle spese;<br>
						(b) la ricezione di importi dovuti dall'utente.
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi
						Di Contatto
						Finanziari
						Sulle operazioni
						Di mercato
						Commerciali
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Esecuzione di un contratto
						Necessari per i nostri legittimi interessi (tra cui il recupero crediti)
				</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per gestire la nostra relazione con l'utente, ivi inclusi:<br>
						(a) le notifiche all'utente relative agli emendamenti alle nostre condizioni d'uso e alle norme sulla privacy;<br>
						(b) la richiesta all'utente di pubblicare una recensione o rispondere a un sondaggio
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi
						Di contatto
						Di profilatura
						Di mercato
						Commerciali
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Esecuzione di un contratto
						Necessari per ottemperare a un obbligo di legge
						Necessari per i nostri interessi legittimi (per aggiornare i nostri archivi e per valutare le modalità di utilizzo dei nostri prodotti/servizi da parte dell'utente)
				</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per inviare all'utente materiale di marketing diretto</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi
						Di contatto
						Di profilatura
						Di mercato
						Commerciali Tecnici
						Di utilizzo
						Di monitoraggio
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per la maggior parte delle comunicazioni
						di marketing diretto ci basiamo sul consenso, nonostante vi siano situazioni in cui rientra nei nostri
						interessi legittimi l'utilizzo dei dati personali</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per la maggior parte delle comunicazioni di marketing diretto ci basiamo sul consenso, nonostante vi siano situazioni
						in cui rientra nei nostri interessi legittimi l'utilizzo dei dati personali</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi
						Di contatto
						Di profilatura
						Di utilizzo
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Esecuzione di un contratto
						Necessari per i nostri interessi legittimi (per valutare la modalità di utilizzo dei nostri prodotti/servizi, per svilupparli e far crescere la nostra attività)
				</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per gestire e proteggere la nostra attività e il presente sito ,
						per esempio, per la risoluzione dei problemi, l’analisi dei dati, lo svolgimento di test, la manutenzione del sistema,
							l’assistenza, la rendicontazione e l’hosting dei dati</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi
						Di contatto
						Tecnici
						Di monitoraggio
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">
						Necessari per i nostri interessi legittimi (per lo svolgimento della nostra attività,
						la fornitura di servizi amministrativi e informatici, la sicurezza della rete, la prevenzione da
						frodi nonché nell'ambito di una riorganizzazione della attività o di una ristrutturazione aziendale)
						Necessari per ottemperare a un obbligo di legge
				</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per offrire all'utente un sito con contenuti e pubblicità
						pertinenti e per misurare o comprendere l'efficacia delle pubblicità trasmesse</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi
						Di contatto Di profilatura
						Di utilizzo
						Di mercato
						Commerciali
						Tecnici
						Di monitoraggio
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Necessari per i nostri interessi legittimi
						(per valutare la modalità di utilizzo dei nostri prodotti/servizi, per svilupparli,
						far crescere la nostra attività e migliorare la nostra strategia di marketing)</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per utilizzare le analisi dei dati allo scopo di migliorare il sito, il prodottto/servizi, il marketing e la relazione con il cliente</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Tecnici
						Di monitoraggio
						Di utilizzo
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Necessari per il nostri interessi legittimi ( Per definite la tipologia di cliente per i nostri prodotti e servizi, per mantenere
							aggiornato e coerente il sito, per sviluppare la nostra attività e migliorare la nostra strategia marketing</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per offrire consiglio e raccomandare all’utente prodotto e servizi a cui potrebbe essere interessato</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi
						Di contatto
						Di profilatura
						Di utilizzo
						Di profilatura
						Commerciali
						Tecnici
						Di monitoraggio
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Necessari per i nostri interessi legittimi (per sviluppare i nostri prodotti/servizi e far crescere la nostra attività)</td>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per prevenire e rilevare atti illeciti</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Identificativi
						Di contatto
						Finanziari
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Per prevenire e rilevare atti illeciti</td>
		</tr>
</table>
<p class="mb-2">7. Pubblicità, marketing e preferenze dell'utente nelle comunicazioni</p>
<p class="mb-1">Potremmo utilizzare i Dati identificativi, di contatto, tecnici, di monitoraggio, di utilizzo e di profilatura per farci un'idea di quello che
		l'utente potrebbe desiderare o che gli potrebbe servire, oppure quello che lo potrebbe interessare. È in questo modo che decidiamo
		quali prodotti, servizi e offerte siano pertinenti per l'utente e, di conseguenza, gli forniamo le relative comunicazioni. È il cosiddetto marketing diretto.
</p>
<p class="mb-1">Potremmo utilizzare strategie di marketing diretto tramite e-mail, telefono, SMS o posta.</p>
<p class="mb-1">Ci impegniamo al massimo affinché il nostro sito comunichi sempre chiaramente le nostre attività e la tipologia di messaggi recapitati all'utente, sia quando è l'utente stesso a decidere di ricevere comunicazioni sia in occasione della creazione dell'account o
		della procedura di acquisto online. L'utente può cambiare idea in ogni momento, ringraziare e decidere di annullare l'iscrizione
		(anche se ci dispiace veder partire un nostro cliente, quindi ti preghiamo comunicarci le tue preferenze e darci una chance prima di dirci definitivamente addio!). Il modo più facile per annullare l'iscrizione è tramite il link apposito in calce alle nostre comunicazioni.
</p>
<p class="mb-1">Abbiamo creato un indirizzo specifico cui potrà indirizzare tutte le sue domande o richieste: <a href="mailto:privacy@dromedian.it">privacy@dromedian.it</a>
</p>
<p class="mb-1">
				Lavoriamo inoltre con dei partner che ci permettono di aumentare il raggio di azione delle nostre pubblicità usando a questo scopo dati analitici e sistemi di retargeting. Utilizziamo i Dati di monitoraggio per offrire pubblicità online che siano pertinenti,
				anche tramite siti e social media.
</p>
<p class="mb-1">
		I Dati di monitoraggio, e in particolare i cookie, ci aiutano a offrire delle pubblicità su siti e social media che, crediamo, siano più interessanti per l'utente e per i potenziali clienti CONCILIUM.
</p>
<p class="mb-1">
		I cookie usati a questo scopo sono spesso installati sul nostro sito da società specializzate. I cookie ci avvertono
		inoltre dell'eventuale visualizzazione da parte dell'utente di una determinata pubblicità,
		nonché del tempo trascorso dalla sua ultima visualizzazione. Sono dati importanti per noi perché ci permettono
		di monitorare l'efficacia delle nostre campagne pubblicitarie nonché tenere sotto controllo il numero di
		volte in cui a una stessa persona appare la medesima pubblicità (non vorremmo diventare ripetitivi). I cookie ci aiutano inoltre a
		capire se l'utente ha aperto una nostra e-mail commerciale, per evitare di inviare contenuti che vengono cestinati.
</p>
<p class="mb-3">
		Per maggiori informazioni sui Dati di monitoraggio, in particolare sui cookie, confrontare la sezione Cookie di seguito.
</p>
<p class="mb-2">
		Cookie
</p>
<p class="mb-1">
		Come si desume dalla sezione Pubblicità, marketing e preferenze dell'utente nelle comunicazioni di cui sopra,
		i cookie sono strumenti che noi (e qualsiasi soggetto che operi online) usiamo a scopi pubblicitari.
		Questo è solo uno degli utilizzi dei cookie. Sono uno strumento molto ingegnoso.
</p>
<p class="mb-1">
		Altri cookie raccolgono informazioni sulle modalità di utilizzo del sito da parte dell'utente, per esempio quali sono
		le pagine visitate più spesso, o se l'utente riceve dei messaggi d'errore da talune pagine. Questi cookie non raccolgono
		informazioni tramite cui si possa identificare l'utente.
		Tutte le informazioni raccolte da questi cookie sono aggregate e usate per migliorare il funzionamento dei nostri siti.
</p>
<p class="mb-1">
		Esistono inoltre dei cookie che permettono ai siti di ricordare le scelte dell'utente
		(come il nome utente, la lingua o la posizione geografica) per mettere a disposizione delle funzionalità non solo migliori,
		ma anche personalizzate. Questi cookie possono anche essere usati per ricordare le modifiche dell'utente relative alla
		dimensione dei caratteri, l'uso dei font e altre preferenze personalizzabili. Possono anche essere usati per
		fornire dei servizi richiesti dall'utente come la visualizzazione di un video o l'inserimento di un commento su un blog.
</p>
<p class="mb-1">
		Questi cookie raccolgono informazioni sulle abitudini di navigazione dell'utente per fornire delle pubblicità pertinenti rispetto agli interessi dell'utente (confrontare pubblicità, marketing e preferenze dell'utente nelle comunicazioni di cui sopra). Sono installati, di solito, da reti pubblicitarie previo nostro consenso. Questi cookie memorizzano il sito visitato in precedenza dall'utente e questa informazione è condivisa con le altre società, per esempio pubblicitarie.
			I cookie definiti come "targeting cookie" o "cookie di pubblicità" sono legati alle funzionalità del sito fornite da altre società.
</p>
<p class="mb-1">
		Quando l'utente consulta il sito concilium.cloud, possono essere utilizzati questi cookie. Tale elenco può variare nel tempo.
</p>
<table style="width:100%" class="border-collapse">
		<tr>
				<th class="p-2 border border-solid d-theme-border-grey-light">Fornitore</th>
				<th class="p-2 border border-solid d-theme-border-grey-light">Id Cookie</th>
				<th class="p-2 border border-solid d-theme-border-grey-light">Finalità</th>
				<th class="p-2 border border-solid d-theme-border-grey-light">Privacy Policy</th>
		</tr>
		<tr>
				<td class="p-2 border border-solid d-theme-border-grey-light">Google Analytics</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">_ga
						visitor_id
						_gat_UA-66896-7
						ga_UA-66896-16
				</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">Google Analytics è un servizio di web analytics fornito da Google Inc. Google Analytics installa
						i cookie per valutare l'uso di detti servizi e fornircene un resoconto.</td>
				<td class="p-2 border border-solid d-theme-border-grey-light">https://policies.google.com/privacy/update?hl=it</td>
		</tr>
</table>
<p class="mb-3">
		N.B.: non abbiamo alcun accesso né controllo sui cookie usati da dette società o da siti terzi. Suggeriamo all'utente di consultare il sito terzo per maggiori informazioni sui suoi cookie e la loro relativa gestione.
		Il programma di navigazione può essere impostato in modo da rifiutare totalmente o parzialmente l'uso dei cookie, oppure per avvisare l'utente quando un sito tenta di installare o accedere a dei cookie. Disabilitando o rifiutando i cookie, l'utente potrebbe vedersi rifiutare l'accesso a determinate sezioni del sito, oppure potrebbe notare che queste non funzionano correttamente.
</p>
<p class="mb-2">
		9. Divulgazione dei dati personali
</p>
<p class="mb-1">
		I dati personali dell'utente possono essere condivisi con i soggetti indicati qui di seguito per le finalità previste dalle presenti norme sulla privacy. Potremmo inoltre condividere
		i dati personali dell'utente qualora sia comunque previsto dalla legge.
</p>
<p class="mb-1">
		Ci riserviamo il diritto di condividere i dati personali con le seguenti categorie di soggetti terzi:
</p>
<ul>
		<li>fornitori di prodotti e servizi (per esempio, fornitori di servizi tecnologici, per l'elaborazione del pagamento e la prevenzione dalle frodi, produttori, servizi di trasporto e servizi postali);</li>
		<li>revisori esterni e consulenti professionisti quali consulenti bancari, legali, contabili e assicurativi;</li>
		<li>enti amministrativi, normativi ed enti che si occupano dell'applicazione della legge</li>
</ul>
<p class="mb-3">
		Richiediamo a tutti i soggetti terzi di rispettare la sicurezza dei dati personali dell'utente e di gestirli ai sensi della normativa vigente. Non concediamo ai fornitori di servizi terzi di usare i dati personali dell'utente per le loro specifiche finalità, bensì concediamo loro esclusivamente di trattare i dati personali dell'utente per gli scopi specificati e conformemente alle nostre istruzioni.
</p>
<p class="mb-2">
		10. Trasferimenti internazionali
</p>
<p class="mb-1">
		L'eventuale trasferimento dei dati personali dell'utente al di fuori dello SEE avverrà sempre ai sensi della normativa sulla protezione dei dati applicabile. Ecco di seguito alcune misure che potremmo decidere di adottare nel portare avanti un trasferimento internazionale.
</p>
<ul>
		<li>Il trasferimento dei dati personali dell'utente avviene verso un Paese i cui livelli di protezione dei dati personali siano stati ufficialmente riconosciuti come soddisfacenti dalla Commissione Europea.</li>
		<li>Potremmo avvalerci di contratti specifici approvati dalla Commissione Europea che offrano ai dati personali la medesima protezione garantita in Europa (chiamati "Clausole modello dell'UE").</li>
		<li>Qualora ci avvalessimo di fornitori di servizi statunitensi, potremmo trasferire loro dei dati se essi aderiscono allo scudo UE-USA per la privacy che richiede loro di garantire una protezione dei dati personali pari a quella offerta in Europa e negli Stati Uniti. Qualora il fornitore non aderisse allo scudo UE-USA per la privacy,
					potremmo avvalerci delle Clausole modello dell'UE.</li>
</ul>
<p class="mb-3">Alcuni dei nostri fornitori di servizi esterni hanno sede in Paesi diversi da quelli dello SEE, quindi il trattamento dei dati personali dell'utente richiede un trasferimento di dati oltre i confini dello stesso.</p>
<p class="mb-2">11. Sicurezza dei dati</p>
<p class="mb-1">Abbiamo istituito delle misure di sicurezza adatte a prevenire la perdita accidentale dei dati personali dell'utente, nonché il
			loro uso o accesso da parte di soggetti non autorizzati, nonché la loro alterazione o diffusione. Inoltre, l'accesso ai dati personali dell'utente è limitato a dipendenti, agenti, appaltatori e altri soggetti terzi che, per ragioni legate allo svolgimento della
		loro attività commerciale, debbano necessariamente conoscere. I dati personali dell'utente saranno trattati esclusivamente dietro nostre istruzioni e questi soggetti sono tenuti all'obbligo di riservatezza.</p>
<p class="mb-3">
		Abbiamo istituito delle procedure per la gestione delle eventuali violazioni dei dati personali e ci preoccuperemo di comunicare tali violazioni all'utente e a qualsivoglia autorità di controllo qualora ciò sia richiesto dalla legge.
</p>
<p class="mb-2"> 12. Link di parti terze</p>
<p class="mb-3">
		Questo sito potrebbe includere dei link a siti terzi, nonché plug-in e applicazioni di soggetti terzi
		(ciò accade ad esempio quando si dà la possibilità di usare il video tramite Zoom). Facendo click su detti link o
		collegandosi ad essi si accetta che i soggetti terzi raccolgano o condividano dei dati dell'utente.
		I siti di parti terze non sono da noi controllati ed Dromedian non è responsabile delle rispettive informative sulla privacy.
		Abbandonando il nostro sito, l'utente è tenuto a leggere le norme sulla privacy di ogni altro sito consultato.
</p>
<p class="mb-2">
				13. Conservazione dei dati Conserveremo i dati personali dell'utente esclusivamente per il tempo necessario ad adempiere alle finalità per cui i dati sono stati raccolti, ivi
				incluse le finalità legate alla soddisfazione di qualsiasi obbligo legale, contabile o di rendicontazione.
</p>
<p class="mb-1">
		Per determinare il corretto periodo di conservazione dei dati personali, consideriamo la quantità,
		la natura e il grado di sensibilità dei dati personali, il potenziale rischio legato a eventuali danni per uso non
			autorizzato o per la diffusione dei dati personali dell'utente,
			le finalità per cui avviene il trattamento e l'eventuale esistenza di alternative, insieme agli obblighi di legge applicabili.
</p>
<p class="mb-1">
				Ai fini fiscali, la legge esige la conservazione delle informazioni di base dei nostri clienti (tra cui i Dati di contatto, identificativi, finanziari e sulle operazioni) per sei anni dal momento della decadenza dello status di cliente.
</p>
<p class="mb-1">
		In talune circostanze, l'utente può chiederci di cancellare i dati che lo riguardano; per maggiori informazioni, consultare la sezione I diritti garantiti dalla legge qui di seguito.
</p>
<p class="mb-3">
		In alcune circostanze potremmo decidere di rendere anonimi i dati personali dell'utente (in modo che non siano più associati alla sua identità) per finalità di ricerca o statistiche. In questi casi,
		ci riserviamo il diritto di utilizzare dette informazioni indefinitamente e senza ulteriore notifica.
</p>
<p class="mb-2">
		14. I diritti garantiti dalla legge
</p>
<p class="mb-1">
		Se il Regolamento europeo in materia di protezione dei dati personali fosse applicato all'utente qualora risieda in un Paese dell'Unione Europea, questi è titolare dei diritti
		di seguito garantiti dalla normativa di protezione della privacy in riferimento ai suoi dati personali.
</p>
<ul>
		<li>Diritto di informazione – abbiamo l'obbligo di informare l'utente sull'utilizzo dei suoi dati personali da parte nostra (obbligo che adempiamo con le presenti norme sulla privacy);</li>
		<li>Diritto di accesso – diritto di inoltrare una "richiesta di accesso ai dati da parte dell'Interessato" per ottenere una copia dei dati personali del soggetto interessato archiviati da Dromedian;
		</li>
		<li> Diritto di rettifica – diritto di esigere la correzione dei dati personali qualora fossero incompleti o scorretti;
		</li>
		<li>
		Diritto di cancellazione – noto anche come "diritto all'oblio" quando, in talune circostanze, l'utente può richiedere di cancellare i dati personali che lo riguardano (sempre che non sussista una norma che preveda il loro mantenimento e che prevalga sulla richiesta);
		</li>
		<li>
				Diritto di limitazione del trattamento – diritto di richiedere, in talune circostante, la sospensione del trattamento dei dati personali;
		</li>
		<li>
				Diritto alla portabilità – diritto di richiedere una copia dei dati personali dell'utente in un formato di uso comune (ad esempio, un file .csv);
		</li>
		<li>
				Diritto di opposizione – diritto di opporsi al trattamento dei dati personali dell'utente (ad esempio, se l'utente non ammetta il trattamento dei dati per finalità di marketing diretto);
		</li>
		<li>
				Diritti legati alle decisioni automatiche e alla profilazione – diritto di esigere la trasparenza per qualsiasi profilazione da noi effettuata, o per qualsiasi decisione presa con un procedimento automatizzato.
		</li>
</ul>
<p class="mb-1">
		Non sono previsti costi per l'accesso ai dati personali dell'utente (o per l'esercizio dei diritti summenzionati). Ciononostante, ci riserviamo il diritto di applicare dei costi considerevoli qualora la richiesta sia evidentemente infondata,
		ripetitiva o eccessiva. In alternativa, e in queste circostanze, potremmo rifiutarci di assecondare la richiesta dell'utente.
</p>
<p class="mb-1">
		Potremmo richiedere delle informazioni specifiche dall'utente per aiutarci a confermare la sua identità e garantire un corretto accesso ai suoi dati personali (o per esercitare uno qualsiasi dei suoi diritti). Questa misura di sicurezza è necessaria per garantire che i dati personali non siano comunicati a qualsiasi soggetto terzo che non abbia il
		diritto di riceverli. Potremmo inoltre contattare l'utente stesso per chiedere ulteriori informazioni in relazione alla sua richiesta in modo da velocizzare la procedura.
</p>
<p class="mb-3">
		Facciamo del nostro meglio per rispondere a tutte le richieste legittime entro un mese. A volte potrebbe occorrere più di un mese qualora la richiesta sia particolarmente complessa oppure l'utente abbia inoltrato numerose richieste.
		In questi casi, sarà nostra premura comunicare le tempistiche all'utente e tenerlo aggiornato.
</p>
<p class="mb-2">
		15. Come contattare Dromedian per una domanda sulla privacy
</p>
<p class="mb-3">
		Per qualsiasi domanda legata alle presenti norme sulla privacy, o qualora si intenda esercitare uno qualsiasi dei diritti dell'utente, è possibile inviarci una e-mail all'indirizzo: privacy@dromedian.it oppure una richiesta scritta all'indirizzo:
</p>
<p class="mb-3">
		Dromedian Srl, Via Po 43 - 66020 San Giovanni Teatino (CH)
</p>
<p class="mb-2">
		16. Ti saremo molto grati se...
</p>
<p class="mb-3">
		È molto importante che i dati personali che riguardano l'utente siano sempre corretti e aggiornati. Ci teniamo quindi ad essere informati qualora i dati personali dell'utente cambiassero
		durante il periodo in cui è in contatto con noi. È possibile comunicarci le modifiche semplicemente comunicandocelo. Grazie!
</p>
<p class="mb-2">
		17. Modifiche alle presenti norme sulla privacy
</p>
<p class="mb-3">
		Il Regolamento europeo in materia di protezione dei dati personali è una normativa recente, e l'autorità garante della privacy sta ancora lavorando per interpretarla e aiutare le aziende ad
		adeguarsi alle novità che essa introduce. È possibile quindi
		che ci siano dei piccoli aggiornamenti alle nostre norme sulla privacy nei prossimi mesi. Consigliamo quindi di tenerle sotto controllo e di rileggerle ogni tanto. Grazie!
</p>

                             -->
</template>

<script>
import { get } from './../../api/privacy-policy'

export default {
	data: () => ({
		content: '<h2>Please wait...</h2>'
	}),
	created() {
		this.getPolicies();
	},
	// computed: {
	// 	content() {
	// 		if(this.policies.length < 1 || !this.$i18n.locale)
	// 			return '<h2>Please wait...</h2>';
	// 		const policy = this.policies.find(policy => policy.locale==this.$i18n.locale);
	// 		if(policy)
	// 			return policy.content;
	// 		const enPolicy = this.policies.find(policy => policy.locale=='en');
	// 		if(enPolicy)
	// 			return policy.content;
	// 		return '<h2>Something went wrong!</h2>';
	// 	}
	// },
	methods: {
		async getPolicies(failed=false) {
			const res = await get(failed?'en':this.$i18n.locale);
			console.log(res.data)
			if(res.data.status=='success')
				this.content = res.data.data.content;
			else if(failed)
				this.content = '<h2>Something went wrong!</h2>'
			else
				this.getPolicies(true);
		}
	}
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
<style scoped>
ul {
  list-style-position: inside;
  list-style-type:disc !important
}
</style>
